// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"152":"ccb7b289","911":"04c8866d"}[chunkId] + ".chunk.css";
};